const CONSTANTS = Object.freeze({
  ENTITY_TYPE: Object.freeze({
    BRAND: "brand",
    CATEGORY: "category",
  }),
  GEO_TYPE: Object.freeze({
    COUNTRY: "COUNTRY",
    POI: "POI",
    STATE: "STATE",
    DMA: "DMA",
  }),
  LAYERS: Object.freeze({
    STATE: "state",
    STATE_BORDER: "state-border",
    STATE_HIGHLIGHTED: "state-highlighted",
    DMA: "dma",
    DMA_BORDER: "dma-border",
    DMA_HIGHLIGHTED: "dma-highlighted",
    POI: "poi",
    POI_INCREMENTAL: "poi_incremental",
    IN_STORE_INCREMENTAL: "instore_incremental",
    ON_LOT_INCREMENTAL: "onlot_incremental",
    IN_STORE: "instore",
    IN_STORE_BORDER: "instore-border",
    IN_STORE_INCREMENTAL_BORDER: "instore_incremental_border",
    ON_LOT_INCREMENTAL_BORDER: "onlot_incremental_border",
    ON_LOT: "onlot",
    ON_LOT_BORDER: "onlot-border",
    GEO_BLOCKS: "geoblocks",
    GEO_BLOCKS_BORDER: "geoblocks-border",
  }),
  SOURCES: Object.freeze({
    STATE: "state",
    DMA: "dma",
    POI: "poi",
    POI_INCREMENTAL: "poi_incremental",
    IN_STORE_INCREMENTAL: "instore_incremental",
    ON_LOT_INCREMENTAL: "onlot_incremental",
    IN_STORE: "instore",
    ON_LOT: "onlot",
    GEO_BLOCKS: "geoblocks",
  }),
  POI_PARTITIONED_LAYERS_COUNT: 18,
  MAP_TYPE: Object.freeze({
    POI: "POI",
    TRADE_AREA: "Trade Area",
    NEARBY_POIS: "Nearby POIs",
  }),
  NEARBY_POIS_MIN_ZOOM: 16,
  LAYERS_CONFIG: Object.freeze({
    STATE_MAX_ZOOM: 4,
    DMA_MIN_ZOOM: 4,
    DMA_MAX_ZOOM: 9,
    DEFAULT_ZOOM: 3,
    CENTER: [-98.396157, 39.825777],
    GEO_HIGHLIGHT_COLOR: "#0083C6",
    POI_ZOOM: 18, // default zoom level to use for while highlighting a selected poi
    POI_MIN_ZOOM: 5, // minimum zoom level before which pois shouldn't be visible
    GEO_BLOCK_ZOOM: 12,
    IN_STORE: {
      FILL_COLOR: "#11cc00",
      FILL_OPACITY: 0.25,
    },
    ON_LOT: {
      FILL_COLOR: "#ff9429",
      FILL_OPACITY: 0.25,
    },
    IN_STORE_BORDER: {
      LINE_COLOR: "#11cc00",
      LINE_OPACITY: 0.9,
    },
    ON_LOT_BORDER: {
      LINE_COLOR: "#ff9429",
      LINE_OPACITY: 0.9,
    },
    BORDER_LAYER: {
      LINE_COLOR: "#4F4F4F",
      LINE_WIDTH: 0.25,
      LINE_OPACITY: 0.7,
    },
    HIGHLIGHTED_LAYER: {
      LINE_COLOR: "#FFFFFF",
      LINE_WIDTH: 2,
      LINE_OPACITY: 1,
    },
  }),
  EVENTS: Object.freeze({
    POI_SELECTED: "poi-selected",
    SHOW_GEOBLOCKS: "show-geo-blocks",
    ZOOM_TO_STATE: "zoom-to-state",
    NEARBY_POIS_ZOOM: "nearby-pois-zoom",
  }),
  LAYOUT_PROPERTIES: Object.freeze({
    VISIBLE: "visible",
    NONE: "none",
  }),
  APP_NAME: "GTMAPLIP",
  POI_LAYER_DEFAULT_COLOR_OPACITY: 1,
  LAYERS_COLOR_PALETTE: Object.freeze({
    TRANSPARENT_COLOR: "rgba(0, 0, 0, 0)",
    FIRST_COLOR: "#fffdc2",
    SECOND_COLOR: "#fff4b1",
    THIRD_COLOR: "#fee89c",
    FOURTH_COLOR: "#feda8c",
    FIFTH_COLOR: "#fec97d",
    SIXTH_COLOR: "#fdb46f",
    SEVENTH_COLOR: "#fba065",
    EIGHTH_COLOR: "#fa8c5b",
    NINTH_COLOR: "#f27655",
    TENTH_COLOR: "#e86559",
    ELEVENTH_COLOR: "#dc555f",
  }),
  CURSOR_TYPES: Object.freeze({
    POINTER: "pointer",
    NOT_ALLOWED: "not-allowed",
    GRAB: "grab",
    BLANK: "",
  }),
});

export default CONSTANTS;
